import { Trans, useTranslation } from 'react-i18next';

import QuestionImage from 'assets/images/question.svg';

import { Button } from 'components/buttons';
import { Buttons, Image } from 'components/modal/styles';

import { Delimiter } from '../styles';
import LABELS from './keys';
import { ModalWithImageContent } from './styles';

interface IncompatibileRailProps {
  onIncompatiblePaymentRailAcknowledge: () => void;
}

const IncompatibileRail = ({ onIncompatiblePaymentRailAcknowledge }: IncompatibileRailProps) => {
  const { t } = useTranslation();

  return (
    <ModalWithImageContent>
      <Image src={QuestionImage} />
      <h1>{t(LABELS.INCOMPATIBLE_PAYMENT_RAIL_TITLE)}</h1>
      <p>
        <Trans
          i18nKey={LABELS.INCOMPATIBLE_PAYMENT_RAIL_DESCRIPTION[0]}
          defaults={LABELS.INCOMPATIBLE_PAYMENT_RAIL_DESCRIPTION[1]}
          components={{ br: <br /> }}
        />
      </p>
      <Delimiter />
      <Buttons>
        <Button secondary onClick={onIncompatiblePaymentRailAcknowledge}>
          {t(LABELS.ACTIONS.BACK_TO_BANK_ACCOUNT)}
        </Button>
      </Buttons>
    </ModalWithImageContent>
  );
};

export default IncompatibileRail;
